import type { NavigateAction, ActionResult } from '../types/actions';
import { waitForPageLoad } from '../utils/wait-utils';

export async function executeNavigateAction(action: NavigateAction): Promise<ActionResult> {
  const startTime = Date.now();

  try {
    // Check if we have an SPA router available
    // @ts-ignore - SPARouter may be defined globally in the page
    const spaRouter = window.spaRouter;

    if (spaRouter && typeof spaRouter.navigate === 'function') {
      // Use SPA router for client-side navigation
      const url = new URL(action.url);
      const path = url.pathname + url.hash;

      // Navigate using SPA router (no page reload)
      await spaRouter.navigate(path);

      // Small delay to allow SPA content to render
      await new Promise(resolve => setTimeout(resolve, 100));

      return {
        success: true,
        action,
        timestamp: Date.now(),
        duration: Date.now() - startTime
      };
    } else {
      // Fallback to traditional navigation (full page reload)
      window.location.href = action.url;

      // Wait for page load if specified
      if (action.waitForLoad !== false) {
        await waitForPageLoad();
      }

      return {
        success: true,
        action,
        timestamp: Date.now(),
        duration: Date.now() - startTime
      };
    }
  } catch (error) {
    return {
      success: false,
      action,
      error: error instanceof Error ? error.message : String(error),
      timestamp: Date.now(),
      duration: Date.now() - startTime
    };
  }
}
